import { render } from "./PlainCard.vue?vue&type=template&id=8b1e6aa8&scoped=true"
import script from "./PlainCard.vue?vue&type=script&lang=js"
export * from "./PlainCard.vue?vue&type=script&lang=js"

import "./PlainCard.vue?vue&type=style&index=0&id=8b1e6aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1e6aa8"]])

export default __exports__